import {
    userInfo
} from "os";
import moment from "moment";
import http from "@/lib/http";
export const commonMixins = {
    data() {
        return {
            months: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            jSonData: [],
            curYear: new Date().getFullYear(),
            last10years: []
        }
    },
    methods: {
        getCustomLabel(keyword) {
            var labels = {
                net_worth: "Net worth (Rs Crore)",
                misc_expenses: "Miscellaneous Expenses",
                sales: "Sales (Rs Crore)",
                assets: "Assets",
                long_term_debt: "Long-term Debt (Rs Crore)",
                dividend_per_share: "Dividend per share (Rs)",
                inventory: "Inventory (Rs Crore)",
                total_dividend_paid: "Total Dividend paid (Rs Crore)",
                dividend_yield: "Dividend Yield",
                depreciation: "Depreciation (Rs Crore)",
                total_debt: "Total Debt (Rs Crore)",
                net_profit: "Net profit (Rs. Crore)",
                number_of_outstanding_shares: "No. of Outstanding Shares",
                number_of_outstanding_shares_calculated: "No. of Outstanding Shares Calculated",
                error_check_no_of_outstanding_shares: "Error check No. of O/S Shares",
                market_cap: "Market Cap",
                price: "Price",
                preferred_equity: "Preferred Equity",
                Short_term_interest_bearing_debt: "Short-term interest bearing debt",
                book_market_ratio: "Book-market ratio (cut-off of top 20% of the market)",
                research_development_costs: "Research Development Costs",
                capex: "Capex (Rs. Crore)",
                cash_eps: "Cash EPS",
                capital_wip: "Capital WIP",
                total_debt_per_equity: "Total Debt per Equity",
                other_manufacturing_expenses: "Other Manufacturing Expenses",
                current__assets: "Current Assets",
                current_liabilities: "Current Liabilities",
                other_current_liabilities: "Other Current Liabilities",
                debtors: "Debtors",
                ebit: "EBIT",
                ebitDA: "EBITDA",
                ebitDA_per_sales: "EBITDA Per Sales",
                ev: "EV",
                ev_per_ebitda: "EV Per EBITDA",
                cfo_per_ebitda: "CFO per EBITDA",
                profit_per_sales: "Net Profit Per Sales",
                price_per_cash_eps: "Price per Cash EPS",
                sales_growth: "Sales Growth",
                profit_growth: "Profit Growth",
                // ebit_mkt_cap_plus_preferred_equity_plus_net_interest_minus_bearing_debt: "EBIT/(Mkt cap plus preferred equity plus net interest-bearing debt)",
                emp_cost: "Employee Cost",
                eps: "EPS (Rs.)",
                calc_eps: "Calculated EPS (Rs.)",
                excess_cash: "Excess cash",
                gross_block: "Gross Block",
                gross_margin: "Gross margin",
                interest: "Interest",
                loans_and_advances: "Loans & Advances",
                lna_per_net_worth: "Loan & Advances per Net Worth",
                change_in_lna_per_net_worth: "Change in Loan & Advances per Net Worth",
                change_in_cfo_per_ebitda: "Change in cfo per EBITDA",
                change_ebitDA_per_sales: "Change in EBITDA per Sales",
                change_gross_margin: "Change in Gross margin",
                gross_margin_movement: "Gross margin movement",
                net_current_assets: "Net Current Assets",
                net_fixed_assets: "Net Fixed Assets (after depreciation)",
                power_n_fuel_cost: "Power & Fuel Cost",
                profit_before_tax: "Profit Before Tax",
                raw_materials: "Raw Materials",
                fringe_benefit_tax: "Fringe Benefit Tax",
                deferred_tax: "Deferred Tax",
                tax: "Tax",
                // ebit_per_net_working_capital_plus_nfa: "EBIT/(Net working capital plus NFA)",
                net_cash_from_operating_activities: "Net cash from operating activities",
                purchased_of_fixed_assets_reported: "Purchase of Fixed Assets",
                net_sales: "Net Sales",
                capital_wip_reported: "Capital WIP Reported",
                roe: "ROE",
                qtr4_eps: "Q4 EPS",
                qtr3_eps: "Q3 EPS",
                qtr2_eps: "Q2 EPS",
                qtr1_eps: "Q1 EPS",
                qtr4_sale: "Q4 Sale",
                qtr3_sale: "Q3 Sale",
                qtr2_sale: "Q2 Sale",
                qtr1_sale: "Q1 Sale",
                extraordinary_profit_loss: "Extraordinary Profit & Loss",
                price_per_share: "Price Per Share",
                eps_before_minority: "EPS before MI Interest (Unit Curr.)",
                eps_before_minority_adj: "EPS before MI Interest (Adj) (Unit Curr.)",
                eps_after_minority_interest: "EPS after Mi Interest (Unit Curr.)",
                eps_after_minority_interest_adj: "EPS after MI Interest (Adj) (Unit Curr.)",
                creditors: "Creditors",
                debtors_per_creditors: "Debtors per Creditors",
                pe_ratio: "P/E Ratio",
                pb_ratio: "P/B Ratio",
                pcf_ratio: "P/CF Ratio",
                pdividend_ratio: "P/Divindend Ratio",
                p_per_s: "P Per S",
                other_income_per_ns: "Other Income per Net Sales",
                raw_materials_per_ns: "Raw Materials per Net Sales",
                power_n_fuel_cost_per_ns: "Power & Fuel cost per Net Sales",
                emp_cost_per_ns: "Employee Cost per Net Sales",
                other_manufacturing_expenses_per_ns: "Other Manufacturing Expenses per Net Sales",
                selling_n_administration_expenses_per_ns: "Selling & Administrating Expenses per Net Sales",
                misc_expenses_per_ns: "Misc Expenses per Net Sales",
                operating_profit_per_ns: "Operating Profit per Net Sales",
                interest_per_avg_debt: "Interest per Avg Debt",
                depre_per_gross_block: "Depreciation per Gross Block",
                tax_per_pbt: "Tax per PBT",
                effective_tax_rate: "Effective Tax Rate",
                dividend_payout_ratio: "Dividend Payout Ratio",
                debtors_per_ns: "Debtors per Net Sales",
                creditors_per_ns: "Creditors per Net Sales",
                oprt_profit: "Operating Profit",
                selling_n_administration_expenses: "Selling & Administration Expenses",
                capex_per_net_profit: "Capex per Net Profit",
                inventory_per_ns: "Inventory per Net Sales",
                depreciation_per_gross_block: "Depreciation per Gross Block",
                total_expenditure: "Total Expenditure",
                total_expenditure_per_ns: "Total Expenditure per Net Sales",
                capitals: "Capitals",
                reserves_total: "Reserves Total",
                equity_share_warrants: "Equity Share Warrants",
                equity_application_money: "Equity Application Money",
                preference_capital_paid_up: "Preference Capital Paid Up",

                //Market Share
                sector_market_cap: "Sector Market Cap",
                sector_total_dividend_paid: "Sector Total Div paid",
                sector_ebitDA_per_sector_sales: "Sector ebitDA/Sector Sales",
                sector_ebitDA: "Sector ebitDA",
                sector_sales: "Sector Sales",
                sector_net_profit: "Sector Net profit",
                sector_market_cap_per_sector_total_dividend_paid: "Sector Market Cap/Sector Total div paid",
                sector_market_cap_per_sector_sales: "Sector Market Cap/Sector Sales",
                sector_market_cap_per_sector_net_profit: "Sector Market Cap/Sector Net profit",

                //Aggregate Data
                avg_capex_per_net_profit: "Capex per Net Profit",
                avg_cfo_per_ebitDA: "CFO per EBITDA",
                avg_creditors_per_ns: "Creditors per NS",
                avg_debtors_per_ns: "Debtors per NS",
                avg_emp_cost_per_ns: "Emp Cost per NS",
                avg_lna_per_net_worth: "Loan & Advances per NS",
                avg_misc_per_ns: "Misc. per NS",
                avg_inventory_per_ns: "Inventory per NS",
                avg_operating_profit_per_ns: "Operating Profit per NS",
                avg_other_income_per_ns: "Other Income per NS",
                avg_other_manExp_per_ns: "Other Manufacturing Expenses per NS",
                avg_power_fuel_cost_per_ns: "Power & Fuel Cost per NS",
                avg_price: "Price",
                avg_raw_materials_per_ns: "Raw Materials per NS",
                avg_selling_n_administration_per_ns: "Selling & Administration per NS",
                //MIN DATa
                min_capex_per_net_profit: "Capex per Net Profit",
                min_cfo_per_ebitDA: "CFO per EBITDA",
                min_creditors_per_ns: "Creditors per NS",
                min_debtors_per_ns: "Debtors per NS",
                min_emp_cost_per_ns: "Emp Cost per NS",
                min_lna_per_net_worth: "Loan & Advances per NS",
                min_misc_per_ns: "Misc. per NS",
                min_inventory_per_ns: "Inventory per NS",
                min_operating_profit_per_ns: "Operating Profit per NS",
                min_other_income_per_ns: "Other Income per NS",
                min_other_manExp_per_ns: "Other Manufacturing Expenses per NS",
                min_power_fuel_cost_per_ns: "Power & Fuel Cost per NS",
                min_price: "Price",
                min_raw_materials_per_ns: "Raw Materials per NS",
                min_selling_n_administration_per_ns: "Selling & Administration per NS",
                //MAX DATa
                max_capex_per_net_profit: "Capex per Net Profit",
                max_cfo_per_ebitDA: "CFO per EBITDA",
                max_creditors_per_ns: "Creditors per NS",
                max_debtors_per_ns: "Debtors per NS",
                max_emp_cost_per_ns: "Emp Cost per NS",
                max_lna_per_net_worth: "Loan & Advances per NS",
                max_misc_per_ns: "Misc. per NS",
                max_inventory_per_ns: "Inventory per NS",
                max_operating_profit_per_ns: "Operating Profit per NS",
                max_other_income_per_ns: "Other Income per NS",
                max_other_manExp_per_ns: "Other Manufacturing Expenses per NS",
                max_power_fuel_cost_per_ns: "Power & Fuel Cost per NS",
                max_price: "Price",
                max_raw_materials_per_ns: "Raw Materials per NS",
                max_selling_n_administration_per_ns: "Selling & Administration per NS",
                //PERCENTAGE DATa
                percentage_variation_capex_per_net_profit: "Capex per Net Profit",
                percentage_variation_cfo_per_ebitDA: "CFO per EBITDA",
                percentage_variation_creditors_per_ns: "Creditors per NS",
                percentage_variation_debtors_per_ns: "Debtors per NS",
                percentage_variation_emp_cost_per_ns: "Emp Cost per NS",
                percentage_variation_lna_per_net_worth: "Loan & Advances per NS",
                percentage_variation_misc_per_ns: "Misc. per NS",
                percentage_variation_inventory_per_ns: "Inventory per NS",
                percentage_variation_operating_profit_per_ns: "Operating Profit per NS",
                percentage_variation_other_income_per_ns: "Other Income per NS",
                percentage_variation_other_manExp_per_ns: "Other Manufacturing Expenses per NS",
                percentage_variation_power_fuel_cost_per_ns: "Power & Fuel Cost per NS",
                percentage_variation_price: "Price",
                percentage_variation_raw_materials_per_ns: "Raw Materials per NS",
                percentage_variation_selling_n_administration_per_ns: "Selling & Administration per NS",
                //Std DEv DATa
                stdev_capex_per_net_profit: "Capex per Net Profit",
                stdev_cfo_per_ebitDA: "CFO per EBITDA",
                stdev_creditors_per_ns: "Creditors per NS",
                stdev_debtors_per_ns: "Debtors per NS",
                stdev_emp_cost_per_ns: "Emp Cost per NS",
                stdev_lna_per_net_worth: "Loan & Advances per NS",
                stdev_misc_per_ns: "Misc. per NS",
                stdev_inventory_per_ns: "Inventory per NS",
                stdev_operating_profit_per_ns: "Operating Profit per NS",
                stdev_other_income_per_ns: "Other Income per NS",
                stdev_other_manExp_per_ns: "Other Manufacturing Expenses per NS",
                stdev_power_fuel_cost_per_ns: "Power & Fuel Cost per NS",
                stdev_price: "Price",
                stdev_raw_materials_per_ns: "Raw Materials per NS",
                stdev_selling_n_administration_per_ns: "Selling & Administration per NS",
                cfo_per_ebitDA: "CFO per EBITDA",
                misc_per_ns: "Misc per Net Sales",
                other_manExp_per_ns: "Other Manufacturing Expenses per Net Sales",
                power_fuel_cost_per_ns: "Power & Fuel Cost per Net Sales",
                selling_n_administration_per_ns: "Selling & Administration per Net Sales",
                //
                total_income: "Total Income",
                total_cost: "Total Cost",
                selling_n_administration: "Selling & Administration Expenses",
                power_n_fuel: "Power & Fuel Expenses",
                other_manExp: "Other Manufacturing Expenses",
                other_income: "Other Income",
                sales_per_invested_capital: "Sales per Invested Capital",
                //MaxValuation
                latest_roe: "Latest ROE",
                current_long_term_treasury_yield: "Current Long-term Treasury Yield",
                roe_per_clty: "ROE per Current Long-term Yield",
                latest_net_worth: "Latest Net Worth",
                max_valuation: "Max Valuation",
                //Intrinsic
                projected_pbt_after_10_year: "Projected PBT after 10 Years",
                projected_pbt_after_10_year_per_share_ten_years: "Projected PBT per share after 10 Years",
                pbt_last_FY: "PBT Last FY",
                pbt_return_after_10_year_on_latest_price: "PBT return after 10 Years on latest price",
                present_value_of_proj_pbt_after_10_years: "Present value of Projected PBT after 10 Years",
                intrinsic_value_per_share: "Intrinsic Value per Share",
                latest_price_per_intrinsic_value: "Latest price per Intrinsic Value",
                latest_price: "Latest Price",
                latest_pe_ratio: "Latest PE",
                corporate_long_term_interest_rate: "Corporate long-term interest rate",
                projected_period: "Projected Period",
                eps_growth_cagr_10_years: "EPS Growth CAGR 10 Years",
                //-------------------------------------
                eps_growth_cagr_5_years: "EPS Growth CAGR 5 Years",
                eps_growth_cagr_manual_years: "EPS Growth CAGR Manual Years",
                projected_pbt_after_5_year: "Projected PBT after 10 Years",
                projected_pbt_after_10_year_per_share_ten_years_5_eps: "Projected PBT per share after 10 Years",
                pbt_return_after_10_year_on_latest_price_5_eps: "PBT return after 10 Years on latest price",
                present_value_of_proj_pbt_after_10_years_5_eps: "Present value of Projected PBT after 10 Years",
                intrinsic_value_per_share_5_eps: "Intrinsic Value per Share",
                latest_price_per_intrinsic_value_5_eps: "Latest price per Intrinsic Value",

                projected_pbt_after_manual_year: "Projected PBT after 10 Years",
                projected_pbt_after_10_year_per_share_ten_years_manual_eps: "Projected PBT per share after 10 Years",
                pbt_return_after_10_year_on_latest_price_manual_eps: "PBT return after 10 Years on latest price",
                present_value_of_proj_pbt_after_10_years_manual_eps: "Present value of Projected PBT after 10 Years",
                intrinsic_value_per_share_manual_eps: "Intrinsic Value per Share",
                latest_price_per_intrinsic_value_manual_eps: "Latest price per Intrinsic Value",
                //-------------------------------------
                retained_earning: "Retained Earnings",
                dividend: "Dividend",
                pbt: "PBT",
                change_in_debt: "Change in Debt",
                equity_raised: "Equity Raised",
                investments: "Investments",
                current_assets: "Current Assets",
                increase_in_current_assets: "Increase in Current Assets",
                decrease_in_creditors: "Decrease in Creditors",
                accumulated_depreciation: "Accumulated Depreciation",
                net_block: "Net Block",
                operational_cash_in_flow: "Operational Cash In Flow",
                operational_cash_out_flow: "Operational Cash Out Flow",
                net_operational_cash_in_flow: "Net Operational Cash In Flow",
                investment_made: "Investment Made",
                non_operational_cash_out_flow: "Non-Operational Cash Out Flow",
                non_operational_cash_in_flow: "Non-Operational Cash In Flow",
                net_cash_in_flow: "Net Cash In Flow",
                opening_cash: "Opening Cash",
                closing_cash: "Closing Cash",
                other_currents_assets: "Other Current Assets",
                total_assets: "Total Assets",
                other_currents_liabilities: "Other Current Liabilities",
                total_liabilities: "Total Liabilities",
                diff_total_assets_minus_total_liabilities: "Difference (Total Assets - Total Liabilities)",
                intrinsic_value: "Intrinsic Value",
                capex_capital_wip_plus_purchased_of_fixed_assets: "Capex Capital WIP plus Purchased of fixed assets",
                free_cash_flow: "Free cash flow",
                total_debt_per_net_worth: "Total debt per net worth",
                //Combined rank
                rank: "Rank",
                companyname: "Company",
                marketCapitalization_latest: "Market Cap (Latest)",
                ebit_per_net_working_capital_plus_nfa: 'EBIT (NWC+NFA)',
                ebit_mkt_cap_plus_preferred_equity_plus_net_interest_minus_bearing_debt: 'EBIT (MC+PE+NI-BD)',
                // ebit_per_net_working_capital_plus_nfa: 'EBIT (NWC+NFA)',
                // ebit_per_net_working_capital_plus_nfa: 'EBIT (NWC+NFA)',
                market_capitalization: "Market Cap (Latest)",
                name: "Company",
                co_code: "Code",
                sector_name: "Sector",
                sectorname: "Sector",
                p1_S: "P1 S",
                p2_S: "P2 S",
                p3_S: "P3 S",
                p4_S: "P4 S",
                p5_a_S: "P5 A S",
                p5_b_S: "P5 B S",
                p6_a_S: "P6 A S",
                p6_b_S: "P6 B S",
                p7_a_S: "P7 A S",
                p7_b_S: "P7 B S",
                p8_a_S: "P8 A S",
                p8_b_S: "P8 B S",
                p10_S: "P10 S",
                p11_S: "P11 S",
                q1_S: "Q1 S",
                q1_a_S: "Q1 A S",
                q1_b_S: "Q1 B S",
                q1_c_S: "Q1 C S",
                q1_d_S: "Q1 D S",
                p6_a: "P6 A S",
                p6_b: "P6 B S",
                ebitnca_actual: "EBIT by NCA",
                ebitmktcap_actual: "EBIT by Mkt Cap",
                ebitnca_gt_500_rank: "EBIT by NCA Rank > 500",
                ebitmktcap_gt_500_rank: "EBIT by Mkt Cap Rank > 500",
                c_gt_500_rank: "Comb Rank > 500",
                ebitnca_gt_zero_rank: "EBIT by NCA Rank > 0",
                ebitmktcap_gt_zero_rank: "EBIT by Mkt Cap Rank > 0",
                c_gt_zero_rank: "> 0 Comb Rank",
                ebitnca_rank: "EBIT by NCA Rank",
                ebitmktcap_rank: "EBIT by Mkt Cap Rank",
                c_rank: "Comb Rank",
                at_average_pe: "At average PE",
                at_current_pe: "At current PE",
                at_lowest_pe: "At lowest PE",
                at_highest_pe: "At highest PE",
                //Raw Data               
                prevclosePrice: "Prev Close Price",
                MarketCapitalization: "Market Cap",
                Pricediff: "Price Diff",
                CompanyName: "Company",
                AvgVol: "Avg Vol",

                DirectorName: "Name",
                DirectorDesignation: "Designation",
                ExecutiveStatus: "Executive Status",
                SerialNumber: "Sr.",
                lname: "Name",
                ISSUETYPE: "Issue Type",
                ISSUESIZE: "Issue Size",
                OPENDATE: "Open Date",
                CLOSDATE: "Close Date",
                Offer_Price: "Offer Price",

                sc_code: 'BSE Code',
                code: 'NSE Code',
                CO_NAME: 'Company',
                LISTDATE: 'Listing Date',
                listprice: 'List Price',
                LISTVOL: 'Listing Volume',
                IssueSize: 'Issue Size',
                OfferPrice: 'Offer Price',
                LastTr_Date: 'Last Traded Date',
                PerChange: '% change',
                IssueDate: 'Issue Date',

                complongname: "Company",
                close_price: "Close Price",
                netchg: "Net Change",
                perchg: "% Change",
                prevclose: "Prev Close Price",
                upddate: "Date",

                co_name: "Company",
                AnnouncementDate: "Announcement Date",
                RecordDate: "Record Date",
                BonusDate: "Bonus Date",
                BonusRatio: "Bonus Ratio",

                DivDate: "Dividend Date",
                DivAmount: "Dividend Amount",
                DivPer: "Dividend %",


                recorddate: "Record Date",
                SplitDate: "Split Date",
                FVBefore: "Face value Before",
                FVAfter: "Face value After",
                SplitRatio: "Split Ratio",
                BMdate: "Board Meeting Date",
                'APATM (%)': "APATM",
                'CPM (%)': "CPM",
                'Current Ratio': "CurrentRatio",
                'Debt-Equity Ratio': "DebtEquityRatio",
                'Debtors': "Debtors",
                'Fixed Assets': "FixedAssets",
                'Interest Cover Ratio': "InterestCoverRatio",
                'Inventory': "Inventory",
                'Long Term Debt-Equity Ratio': "LongTermDebtEquityRatio",
                'PBDTM (%)': "PBDTM",
                'PBIDTM (%)': "PBIDTM",
                'PBITM (%)': "PBITM",
                'ROCE (%)': "ROCE",
                'RONW (%)': "RONW",
                'TotalAssetTurnoverRatio': 'TotalAssetTurnoverRatio',

                'APATM': "APATM (%)",
                'CPM': "CPM (%)",
                'CurrentRatio': "Current Ratio",
                'DebtEquityRatio': "Debt-Equity Ratio",
                'FixedAssets': "Fixed Assets",
                'InterestCoverRatio': "Interest Cover Ratio",
                'TotalAssetTurnoverRatio': "Total Asset Turnover Ratio",
                'LongTermDebtEquityRatio': "Long Term Debt-Equity Ratio",
                'PBDTM': "PBDTM (%)",
                'PBIDTM': "PBIDTM (%)",
                'PBITM': "PBITM (%)",
                'ROCE': "ROCE (%)",
                'RONW': "RONW (%)",

                capitalworkinprogress: "Capital WIP",
                cashandbankbalance: "Cash & Bank balance",
                coname: "Company Name",
                contingentliabilities: "Contingent Liabilities",
                currentliabilities: "Current Liabilities",
                grossblock: "Gross block",
                inventories: "Inventories",
                lessaccumdepreciation: "Less: Accum. Depreciation",
                loansandadvances: "Loan & Advances",
                miscellaneousexpensesnotwo: "Misc Expenses not w/o",
                netblock: "Net Block",
                netcurrentassets: "Net Current Assets",
                provisions: "Provisions",
                reservessurplus: "Reserves Surplus",
                securedloans: "Secured Loans",
                sharecapital: "Share Capital",
                sundrydebtors: "Sundry Debtors",
                totalassets: "Total Assets",
                totaldebt: "Total Debt",
                totalliabilities: "Total Liabilities",
                totalshareholdersfunds: "Total Share holders funds",
                unsecuredloans: "Unsecured Loans",
                year: "Year",

                apatmpercentage: "APATM (%)",
                cpmpercentage: "CPM (%)",
                currentratio: "Current Ratio",
                'debt-equityratio': "Debt-equity Ratio",
                fixedassets: "Fixed assets",
                interestcoverratio: "Interest cover ratio",
                'longtermdebt-equityratio': "Long term Debt-equity ratio",
                pbdtmpercentage: "PBDTM (%)",
                pbidtmpercentage: "PBIDTM (%)",
                pbitmpercentage: "PBITM (%)",
                rocepercentage: "ROCE (%)",
                ronwpercentage: "RONW (%)",

                adjustmentbelownetprofit: "Adjustment below Net profit",
                appropriations: "Appropriations",
                bookvalue: "Book Value",
                corporatedividendtax: "Corporate Dividend Tax",
                earningpersharers: "Earning per shares (Rs.)",
                employeecost: "Employee Cost",
                equitydividend: "Equity dividend",
                equitydividendpercentage: "Equity dividend %",
                exciseduty: "Excise Duty",
                extraordinaryitems: "Extra-ordinary items",
                interestfinancialcharges: "Interest financial charges",
                lesspreoperativeexpenditurecapitalised: "Less pre Operative expenditure capitalised",
                miscellaneousexpenses: "Misc Expenses",
                otherincome: "Other Income",
                othermanufacturingexpenses: "Other Manufacturing Expenses",
                plbalancebroughtforward: "PNL Balance B/F",
                plbalcarrieddown: "PNL Bal C/D",
                powerfuelcost: "Power Fuel Cost",
                preferencedividend: "Preference Dividend",
                profitaftertax: "Profit after Tax",
                profitbeforedepreciationtax: "Profit before Depreciation & Tax",
                profitbeforeinterestdepreciationtax: "Profit before Interest, Depreciation &Tax",
                profitbeforetax: "Profit before Tax",
                rawmaterials: "Raw Materials",
                salesturnover: "Sales Turnover",
                sellingandadministrationexpenses: "Selling & Administration Expenses",
                stockadjustments: "Stock Adjustments",
                totalincome: "Total Income",

                //Insider Transactions
                PERSONNAME: "Name of Acquirer/Seller",
                CATEGORYear: "Category of person",
                SECTYearPEPR: "Type of Securities held Prior to acquisition/Disposed)",
                SECNOPR: "Number of Securities held Prior to acquisition/Disposed",
                SECPERCPR: "% of Securities held Prior to acquisition/Disposed",
                SECTYearPE: "Type of Securities Acquired/Disposed/Pledge etc.",
                SECNO: "Number of Securities Acquired/Disposed/Pledge etc.",
                SECVALUE: "Value of Securities Acquired/Disposed/Pledge etc",
                TRANSTYearPE: "Transaction Type ( Buy/Sale/Pledge/Revoke/Invoke)",
                SECTYearPEPO: "Type of Securities held Post  acquisition/Disposed/Pledge  etc",
                SECNOPO: "Number of Securities held Post  acquisition/Disposed/Pledge etc",
                SECPERCPO: "Post-Transaction % of Shareholding",
                FROMDTACQ: "Date of acquisition of shares/sale of shares/Date of Allotment(From date)",
                TODTACQ: "Date of acquisition of shares/sale of shares/Date of Allotment( To date  )",
                INTDATE: "Date of Intimation to Company",
                ACQMODE: "Mode of Acquisition",
                EXCH: "Exchange on which the Trade was executed",
                REPEXCH: "Reported to Exchange Date",
                SECPERC: "No. of Shares Transacted-%",

                //Companies
                bsecode: "BSE Code",
                nsesymbol: "NSE Symbol",
                companyshortname: "Company Short Name",
                categoryname: "Category Name",
                isin: "ISIN",
                bsegroup: "BSE Group",
                mcaptype: "Market Cap Type",
                sectorcode: "Sector Code",
                govtflag: "Government Flag",

                financial: "Financial",
                medical: "Medical",
                sect_code: "Code",
                sect_name: "Name",
                service: "Service",
                technology: "Technology",
                "utility/telecom/railroad": "Utility/Telecom/Railroad",

                symbol: "Symbol",
                Price: "Price",
                prev_BSE52WHigh: "Previous BSE 52 Week High",
                prev_NSE52WHigh: "Previous NSE 52 Week High",
                prev_BSE52WHighDate: "Previous BSE 52 Week High Date",
                prev_NSE52WHighDate: "Previous NSE 52 Week High Date",
                prev_BSE52WLow: "Previous BSE 52 Week Low",
                prev_NSE52WLow: "Previous NSE 52 Week Low",
                prev_BSE52WLowDate: "Previous BSE 52 Week Low Date",
                prev_NSE52WLowDate: "Previous NSE 52 Week Low Date",
                currmcap: "Current Market Capitalization",
                upd_time: "Update Time",
                high: "High Price",
                low: "Low Price",
                pchange: "Percentage Change",
                volume: "Volume",
                chg: "Change",

                Symbol: "Symbol",
                CompanyLongName: "Company",
                Caption: "Caption",
                Date: "Date",
                memo: "memo",
                date: "Trade Date",
                turnov_bse: "TURNOVER BSE",
                turnov_nse: "TURNOVER NSE",

                AsOnDate: "As on Date",
                sharesoutstanding: "Shares OutStanding",

                YearRC: "Year",

                yrc: "Year",
                EquityDividend: "Equity Dividend",
                DividendPecentage: "Dividend%",
                DivYearield: "Dividend Yearield",

                BSECODE: "Security Code",

                PROMOTER: "Promoter/Promoter Group",
                TRANSPEROD: "Transaction Period",
                ACQSALE: "Acq/Sale",
                MODEBUYearSAL: "Mode of Buy/Sale",
                NOOFSHARES: "No. of Shares/Voting Rights/Warrants Transacted Quantity",
                PERCSHARES: "No. of Shares/Voting Rights/Warrants Transacted %",
                HOLDQUANT: "Holding After Transaction Quantity",
                HOLDPTCAP: "Holding After Transaction % (w.r.t Total Capital)",
                HOLDPDCAP: "Holding After Transaction % (w.r.t Diluted Capital)",
                REGULATION: "Regulation",

                CapitalExpenditure: "Capital Expenditure",
                RecurringExpenditure: "Recurring Expenditure",
                TotalExpendiiture: "Total Expendiiture",
                TotalRDexpenditureaspercentageofnetturnover: "Tot Exp as % of Net Turn over",

                BSEDate: "BSE Date",
                BSEPrice: "BSE Price",
                NSEDate: "NSE Date",
                NSEPrice: "NSE Price",
                MCAP: "MCAP",
                SharesOutstanding: "Shares Outstanding",

                IndustryCode: "Industry Code",
                IndustryName: "Industry Name",

                holidaydate: "Date",
                purpose: "Purpose/Reason",
                day: "Day",

                yearendmonth: "Year End Month",

                yrc: "Financial Year",
                capitalexpenditure: "Capital Expenditure",

                ComapnyName: "Company",
                StartDate: "Start Date",
                EndDate: "End Date",
                Note: "Note",

                oldname: "Old Name",
                newname: "New Name",
                xdate: "Source Date",

                InstName: "Instrument Name",
                ExpDate: "Expiry Date",

                opttype: "Option Type",
                OptType: "Option Type",
                StrikePrice: "Strike Price",
                LTP: "Last Trading Price",
                TradedQty: "Traded Quantity",
                TurnOver: "Turnover",
                opt_input: "Option",
                FAODiff: "F&O Change",
                OI: "Open Interest",
                Qty: "Traded Quantity",
                Value: "Value",

                FAODiff: "F&O Change",
                OI: "Open Interest",

                Details: "Instrument Name",
                Buy_NoOfContracts: "Buy No Of Contracts",
                Buy_Value: "Buy Value",
                Sell_NoOfContracts: "Sell In No Of Contracts",
                Sell_Value: "Sell Value",
                NetBuySellValue: "Net Value in Buy / Sell",
                OI_NoOfContracts: "Open Interest In No Of Contracts",
                OI_Value: "Open Interest in Value",

                UPDDate: "Updated Date Time",
                Instrument: "Instrument Name",
                Underlying: "Underlying",
                Maturity_Date: "Maturity Date",
                Stlmnt_Price: "Settlement date",
                UpdTime: "Updated Date",

                expdate: "Expiry Date",
                PutOI: "Put Open interest",
                CallOI: "Call Open interest",
                TotOI: "Total Open interest",
                PCRatioOI: "Ratio Open interest",
                PutQty: "Put Volume",
                CallQty: "Call Volume",
                TotQty: "Total Volume",
                PCRatioQty: "Ratio Volume",

                SYMBOL: "Symbol",
                CLOSEPRICE: "Close Price",
                ltp: "Last Trade Price",
                FARDATE: "Fard Date",
                COC: "Cost Of Carry",
                openinterest: "Open Interest",
                chg: "% Changes",

                OI: "Open Interest",
                MWPL: "MWPL",
                MWPLChg: "% MWPL",

                CurrentOI: "Current Open Interest",
                CurrentChgOI: "Current Open Interest Change",
                NextOI: "Next Open Interest",
                NextOIChg: "Next Open Interest Change",
                TodayRollOver: "Today Roll Over",
                LastRollOver: "Last Roll Over",
                TotalRollOver: "Total Roll Over",
                RollOver: "Toll Over",
                BaseOI: "Base Open Interest",

                ExpDate: "Expiry Date",
                OptPrice: "Opt Price",
                underly: "Underlying Value",
                optType: "Option Type",
                strikeprice: "Strike Price",
                IV: "Implied Volatility",

                TradedQty: "Traded Quantity",
                TradedValue: "Traded Value",

                HighPrice: "High Price",
                LowPrice: "Low Price",
                OpenPrice: "Open Price",
                ClosePrice: "Close Price",
                OpenInterest: "Open Interest",
                PreviousClose: "Previous Close",
                PercentChange_OpenInterest: "% Open Interest",

                type: "Futures",
                advance: "Advance",
                decline: "Decline",
                unchanged: "Unchanged",
                total: "Total count of advance, decline and unchanged",

                FaoChange: "F&O change",
                ChgOpenInt: "% Change in Open interest",

                date: "Date",
                type: "Type",
                name: "Name",
                noofshares: "No of Shares",
                perstake: "Per Stake",

                YRC: "Year",
                PRNAME: "Product Name",
                UnitofMeasurement: "Unit Of Measurement",
                SalesPercentage: "Sales %",
                InstalledCapacity: "Installed Capacity",
                Production: "Production",
                SALEQTY: "Sale Quantity",
                SALEVAL: "Sale Value",

                large: "Large Cap",
                midlevel: "Mid Cap",
                small: "Small Cap",
                micro: "Micro Cap",

                q1_a_b_greater: "Greater of Q1A/Q1B",
                p11_S: "P11 S",
                p11_quarterly_trends: "Querterly Trend",

                Cash_Deposit: "Cash / Deposit (%)",
                Credit_Deposit: "Credit-Deposit(%)",
                IndustryName: "Banks - Private Sector",
                InterestExpended_InterestEarned: "Interest Expended / Interest Earned (%)",
                InterestExpended_TotalFunds: "Interest Expended / Total Funds (%)",
                InterestIncome_TotalFunds: "Interest Income / Total Funds (%)",
                Investment_Deposit: "Investment / Deposit (%)",
                NetInterestIncome_TotalFunds: "Net Interest Income / Total Funds (%)",
                NetProfit_Totalfunds: "Net Profit / Total funds (%)",
                NonInterestIncome_TotalFunds: "Non Interest Income / Total Funds (%)",
                OperatingExpenses_TotalFunds: "Operating Expenses / Total Funds (%)",
                OperatingExpenses_TotalIncome: "Operating Expenses / Total Income (%)",
                OtherIncome_TotalIncome: "Other Income / Total Income (%)",
                ProfitbeforeProvisions_TotalFunds: "Profit before Provisions / Total Funds (%)",
                RONW: "RONW (%)",

                "Cash / Deposit (%)": "CashDeposit",
                "Credit-Deposit(%)": "CreditDeposit",
                "Banks - Private Sector": "IndustryName",
                "Interest Expended / Interest Earned (%)": "InterestExpendedInterestEarned",
                "Interest Expended / Total Funds (%)": "InterestExpendedTotalFunds",
                "Interest Income / Total Funds (%)": "InterestIncomeTotalFunds",
                "Investment / Deposit (%)":"InvestmentDeposit",
                "Net Interest Income / Total Funds (%)":"NetInterestIncomeTotalFunds",
                "Net Profit / Total funds (%)": "NetProfitTotalfunds",
                "Non Interest Income / Total Funds (%)":"NonInterestIncomeTotalFunds",
                "Operating Expenses / Total Funds (%)":"OperatingExpensesTotalFunds",
                "Operating Expenses / Total Income (%)":"OperatingExpensesTotalIncome",
                "Other Income / Total Income (%)":"OtherIncomeTotalIncome",
                "Profit before Provisions / Total Funds (%)":"ProfitbeforeProvisionsTotalFunds",
                "RONW (%)":"RONW",
                
            };
            // console.log("Label", labels[keyword], keyword);
            return labels[keyword];
        },
        getLabel(keyword) {
            // console.log(keyword);
            if (keyword) {
                keyword = keyword.split("_").join(" ");
                return this.capitalizeFirstLetter(keyword);
            } else return keyword;
        },
        getFixed2dec(num) {
            num = parseFloat(num);
            // return num;
            let n = num < 0 ? Math.floor(Math.abs(num) * 100) * -1 / 100 : num.toFixed(2);
            // return num;
            return n != "NaN" ? n : "-";
        },
        getFixed(num) {
            num = parseFloat(num);
            // return num;
            let n = num < 0 ? Math.floor(Math.abs(num) * 100000) * -1 / 100000 : num.toFixed(4);
            // return num;
            return n != "NaN" ? n : "-";
        },
        getChecknFixed(num) {
            // let n = parseFloat(num).toFixed(4);
            // console.log(num);
            var num1 = parseFloat(num);
            let n = num1 < 0 ? Math.floor(Math.abs(num1) * 1000000) * -1 / 1000000 : num1.toFixed(5);
            // console.log(num,this.actTab, parseInt(n));
            n = (n !== "NaN") ? n : "-";
            return (typeof num === 'string') ? num : n;
        },
        getUnit(label) {
            if (label.search("crore") !== -1) return "Cr.";
            if (label.search("%") !== -1) return "%";
            return "";
        },
        getQuarterStringAddCalender(index) {
            if (index[index.length - 1] == 3)
                return "Calender " + index.replace("03", " Q1");
            if (index[index.length - 1] == 6)
                return "Calender " + index.replace("06", " Q2");
            if (index[index.length - 1] == 9)
                return "Calender " + index.replace("09", " Q3");
            if (index[index.length - 1] == 2)
                return "Calender " + index.replace("12", " Q4");
            return index;
        },
        getHlfYrStringAddCalender(index) {
            index = index.replace("Y", "Year");
            if (index[index.length - 1] == 6)
                return "Calender " + index.replace("06", " Q1");
            if (index[index.length - 1] == 2)
                return "Calender " + index.replace("12", " Q2");
            return index;
        },
        getQuarterString(index) {
            if (index[index.length - 1] == 3) return index.replace("03", " Q1");
            if (index[index.length - 1] == 6) return index.replace("06", " Q2");
            if (index[index.length - 1] == 9) return index.replace("09", " Q3");
            if (index[index.length - 1] == 2) return index.replace("12", " Q4");

            return index;
        },
        getQuarterDigits(str, ind=4) {
            return str.substring(ind);
        },
        getYearFromQuarterString(index) {
            if (index[index.length - 1] == 3) return index.replace("03", "");
            if (index[index.length - 1] == 6) return index.replace("06", "");
            if (index[index.length - 1] == 9) return index.replace("09", "");
            if (index[index.length - 1] == 2) return index.replace("12", "");
            return index;
        },
        getFinancialYearString(index) {
            return (
                "FY " +
                index.replace("20", "") +
                "-" +
                (parseInt(index.replace("20", "")) + 1)
            );
        },
        getFinancialYear(index, tabType) {
            var str = "";
            str = (tabType === "quarterly_result" || tabType === "half_yearly_result") ? this.getQuarterString(index).replace("Year", "") : "FY " + (parseInt(index.substring(3, 5)) - 1) + "-" + index.substring(3, 5);
            return str;
        },
        checkIfHeader(value){
            if(value.indexOf(':') === (value.length-1)) {
                return true;
            } else return false;
        },
        getrowLabel(keyword) {
            keyword = keyword.split("_").join(" ");
            return this.capitalizeFirstLetter(keyword);
        },
        capitalizeFirstLetter(string) {
            if (string !== '') {
                return string.charAt(0).toUpperCase() + string.slice(1);
            } else return string;
        },
        sorted_fields_desc(data, field) {
            return data.sort((a, b) => {
                // console.log(a[field], b[field]);
                return a[field] < b[field] ? 1 : b[field] < a[field] ? -1 : 0;
            });
        },
        sorted_fields_asc(data, field) {
            return data.sort((a, b) => {
                // console.log(a[field], b[field]);
                return a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0;
            });
        },
        getFormattedDatewithTime(dt) {
            var d = new Date(dt);
            if (d != 'Invalid Date') {
                return (
                    this.months[d.getMonth()] +
                    " " +
                    d.getDate() +
                    ", " +
                    d.getFullYear() +
                    " " +
                    d.getHours() +
                    ":" +
                    d.getMinutes()
                );
            } else return dt;
        },
        getMonthYear(dt) {
            var d = new Date(dt);
            if (d != 'Invalid Date')
                return (this.months[d.getMonth()] + "-" + d.getFullYear());
            else return dt;
        },
        getDDMonthYear(dt) {
            var d = new Date(dt);
            if (d != 'Invalid Date')
                return ('0' + d.getDate()).slice(-2) + " " + (this.months[d.getMonth()] + ", " + d.getFullYear());
            else return dt;
        },
        getDate(dt) {
            var d = new Date(dt);
            // console.log(d, d != 'Invalid Date', d != 'Invalid Date');
            if (d != 'Invalid Date')
                return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
            else return dt;
        },
        getDateNew(dt) {
            var d = new Date(dt);
            // console.log(d, d != 'Invalid Date', d != 'Invalid Date');
            if (d != 'Invalid Date'){
                let day = d.getDate();
                let month = (d.getMonth() + 1);

                day = String(day).length === 1 ? "0"+day : day;
                month = String(month).length === 1 ? "0"+month : month;
                return day + "-" + month + "-" + d.getFullYear();
                //return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();
            } else {
                return dt;
            };
        },
        fixDate(dateString) {
            var d = new Date(dateString);
            //if(String(d) === "Invalid Date"){
                //console.log('dateString=>', dateString.indexOf("T"))
                if(dateString.indexOf("T") !== -1){
                    // Split the date and time parts
                    let [datePart, timePart] = dateString.split("T");
                
                    // Split the date into year, month, and day
                    let [year, day, month] = datePart.split("-");
                
                    // Convert to proper format if day exceeds valid range
                    if (parseInt(day) > 31 || parseInt(month) > 12) {
                        [day, month] = [month, day]; // Swap day and month
                    }
    
                    // Rebuild the date string
                    return `${year}-${month}-${day}T${timePart}`;
                }else{
                    return new Date(dateString);
                }
            //}else{
                //return dateString;
            //}
        },
        getYMDDate(dt) {
            var d = new Date(dt);
            // console.log(d, d != 'Invalid Date', d != 'Invalid Date');
            if (d != 'Invalid Date')
                return d.getFullYear() + "-" + ("0" +(d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
            else return dt;
        },
        getDateTime(dt) {
            var d = new Date(dt);
            if (d != 'Invalid Date')
                return d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + ' ' + d.getHours() + ':' + d.getMinutes();
            else return dt;
        },
        getFormattedDate(dt, format) {
            if (format == null){
                var d = new Date(dt);
            } else {
                var dateMomentObject = moment(dt, format); // 1st argument - string, 2nd argument - format
                var d = dateMomentObject.toDate();
            }
            if (d != 'Invalid Date') return (this.months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear());
            else return dt;
        },
        getMonthYear(dt) {
            var d = new Date(dt);
            if (d != 'Invalid Date') return this.months[d.getMonth()] + " " + d.getFullYear();
            else return dt;
        },
        getLastTenYears() {
            for (var i = 0; i < 10; i++) {
                this.last10years.push(this.curYear - i);
            }
            console.log("Last 10 years", this.last10years);
            return this.last10years;
        },
        getYearFromQrtr(d) {
            if (d[d.length - 1] == 3) return d.replace("03", "");
            if (d[d.length - 1] == 6) return d.replace("06", "");
            if (d[d.length - 1] == 9) return d.replace("09", "");
            if (d[d.length - 1] == 2) return d.replace("12", "");
            return d;
        },
        getQuarterName(index) {
            if (index[index.length - 1] == 3) return "Mar " + index.replace("03", "");
            if (index[index.length - 1] == 6) return "Jun " + index.replace("06", "");
            if (index[index.length - 1] == 9)
                return "Sept " + index.replace("09", "");
            if (index[index.length - 1] == 2) return "Dec " + index.replace("12", "");
            return index;
        },
        sorted_fields_date(data, field) {
            return data.sort((a, b) => {
                a[field] = new Date(a[field]);
                b[field] = new Date(b[field]);
                // console.log(a[field], b[field]);
                return a[field] < b[field] ? 1 : b[field] < a[field] ? -1 : 0;
            });
        },
        sorted_fields_date_asc(data, field) {
            return data.sort((a, b) => {
                a[field] = new Date(a[field]);
                b[field] = new Date(b[field]);
                // console.log(a[field], b[field]);
                return a[field] > b[field] ? 1 : b[field] > a[field] ? -1 : 0;
            });
        },
        isPercentValue(val) {
            return this.percentField.includes(val);
        },
        selected(data, param) {
            return data.indexOf(param);
        },
        //Form Set
        setFormData() {
            for (var index in this.fields) {
                let field = this.fields[index];
                // console.log(
                //     (field.reletedField.length > 0) + " => Fields Created",
                //     field
                // );
                if (!field.placeholder) field.placeholder = "";
                if (!field.value) field.value = "";
                if (!field.help) field.help = "";
                this.$set(this.formData, field.name, field.value);
                if (field.reletedField.length > 0) {
                    // console.log("related");
                    let relatedData = field.reletedField;
                    for (var ind in relatedData) {
                        // console.log(relatedData[ind]);
                        let field1 = relatedData[ind];
                        // console.log(
                        //     "RelatedFields",
                        //     field1.value,
                        //     field.name,
                        //     field1.name,
                        //     field1.type
                        // );
                        if (!field1.placeholder) field1.placeholder = "";
                        if (!field1.value) field1.value = "";
                        if (!field1.help) field1.help = "";
                        if (!field1.type) field1.type = "";
                        this.$set(this.formData, field1.name, field1.value, field1.type);
                    }
                }
            }
            console.log("this.formData", this.formData);
        },
        //Company Details
        showCompDetails(row) {
            console.log("view clicked", row);
            localStorage.setItem("selcomp", JSON.stringify({ companyname: (row.companyname) ? row.companyname : row.name, co_code: row.co_code }));
            // http.post("final_data", { co_code: row.co_code }, (error, response) => {
            //   // console.log("RawData", response);
            //   localStorage.setItem("selcomp", JSON.stringify({companyname: row.companyname, co_code: row.co_code}));
            //   let company = response.data.length > 0 ? response.data[0] : [];
            this.$router.push({
                name: "viewcompany",
                params: { company: {} }
                // });
                //TODO:: add company updates into our array in future
            });
        },
        checkIfAllNull(obj) { //Check if all object property/values are null
            var isAllValuesNullOrZero = false;
            var cntZero = 0;
            Object.keys(obj).forEach(function (key, index) {
                // key: the name of the object key
                // index: the ordinal position of the key within the object
                // console.log(key);
                if (
                    key !== "RID" &&
                    key !== "RowNumber" &&
                    key !== "ColumName" &&
                    key !== "rid" &&
                    key !== "rownumber" &&
                    key !== "columnname" &&
                    key !== "rowno"
                ) {
                    // if (obj[key] !== null || parseInt(obj[key]) > 0) {
                    if (parseInt(obj[key]) === 0) {
                        cntZero++;
                    }
                    // console.log(key, "type of " + obj[key], typeof parseInt(obj[key]));
                    // isAllValuesNullOrZero = false;
                    // return false;
                    // }
                }
            });
            if (cntZero == Object.keys(obj).length - 3) {
                isAllValuesNullOrZero = true;
            }
            return isAllValuesNullOrZero;
        },
        getTableFields(data) {
            var tableFields = [];
            var i = 1;
            for (let tb in data) {
                // console.log(tb, data[tb]);
                if (tb !== "percentage") {
                    if (typeof data[tb] == "object") {
                        i = i + 1;
                        let subF = this.sorted_fields_asc(
                            this.getSubTableFields(data[tb], i),
                            "sort_order"
                        );
                        tableFields.push({
                            title: tb,
                            name: this.getLabel(tb),
                            open: false,
                            isAccord: true,
                            sort_order: parseInt(tb.replace(/^\D+/g, "")),
                            subFields: subF,
                            arrange_order: i
                        });
                    } else {
                        tableFields.push({
                            title: tb,
                            name: this.getLabel(tb),
                            open: false,
                            isAccord: false,
                            sort_order: parseInt(tb.replace(/^\D+/g, "")),
                            subFields: [],
                            arrange_order: 111111
                        });
                    }
                } else {
                    this.percentField = data[tb];
                }
            }
            this.tableFields = this.sorted_fields_asc(tableFields, "arrange_order");
            console.log("Table Fields", tableFields);
        },
        getSubTableFields(data, inc) {
            var SubFields = [];
            for (let tb in data) {
                if (typeof data[tb] == "object") {
                    var SubFields1 = [];
                    for (let t in data[tb]) {
                        if (typeof data[tb][t] !== "object") {
                            SubFields1.push({
                                title: t,
                                name: this.getLabel(t),
                                open: false,
                                isAccord: true,
                                sort_order: parseInt(t.replace(/^\D+/g, "")),
                                subFields: [],
                                arrange_order: parseInt(inc)
                            });
                        }
                    }
                    SubFields1 = this.sorted_fields_asc(SubFields1);
                    SubFields.push({
                        title: tb,
                        name: this.getLabel(tb),
                        open: false,
                        isAccord: true,
                        sort_order: parseInt(tb.replace(/^\D+/g, "")),
                        subFields: SubFields1,
                        arrange_order: 111111
                    });
                } else {
                    SubFields.push({
                        title: tb,
                        name: this.getLabel(tb),
                        open: true,
                        isAccord: true,
                        sort_order: parseInt(tb.replace(/^\D+/g, "")),
                        subFields: [],
                        arrange_order: parseInt(inc)
                    });
                }
            }
            return SubFields;
        },
        getDownLoadableData(tableHeadings, tableData, orgData = null, dataKey = null) {
            //For Performance and Valuation
            var jSonData = [];
            var i = 1;
            jSonData[0] = [''];
            tableData.forEach((val, key) => {
                jSonData[0].push(this.getFinancialYearString(val));
            });
            tableHeadings.forEach((hVal, hKey) => {
                jSonData[i] = [];
                jSonData[i].push(this.getLabel(hVal));
                tableData.forEach((val, key) => {
                    // console.log(val, dataKey, key, hVal);
                    if (dataKey !== null) {
                        jSonData[i].push(this.getFixed(orgData[dataKey][val][hVal]));
                    } else {

                    }
                });
                i++;
            });
            // console.log(jSonData);
            return [tableHeadings, jSonData];
        },
        getDownLoadableDataFromTablewithOrgkey(tableHeadings, tableData, orgData = null, dataKey = null) {
            //Industry
            var jSonData = [];
            var i = 1;
            jSonData[0] = [''];
            tableHeadings.forEach((val, key) => {
                jSonData[0].push(val.name);
            });
            tableData.forEach((hVal, hKey) => {
                jSonData[i] = [];
                jSonData[i].push(hVal.name);
                tableHeadings.forEach((val, key) => {
                    console.log(val, dataKey, key, hVal);
                    if (dataKey !== null) {
                        jSonData[i].push(orgData[val[dataKey]][val.title][hVal.title]);
                    } else {

                    }
                });
                i++;
            });
            console.log(jSonData);
            return [tableHeadings, jSonData];
        },
        getDownLoadableDataFromTable(tableHeadings, tableData, dataKey = null) {
            //Market Share
            var jSonData = [];
            var i = 1;
            jSonData[0] = [];
            tableHeadings.forEach((val, key) => {
                jSonData[0].push(val.name);
            });
            tableData.forEach((hVal, hKey) => {
                jSonData[i] = [];
                tableHeadings.forEach((val, key) => {
                    // console.log(val, dataKey, key, hVal);
                    if (dataKey !== null) {
                        (val.isNumeric) ?
                            jSonData[i].push(this.getFixed(hVal[val[dataKey]])) : jSonData[i].push(hVal[val[dataKey]]);
                    } else {

                    }
                });
                i++;
            });
            // console.log(tableHeadings, jSonData);
            return [tableHeadings, jSonData];

        },
        sortColumn(field, ind) {
            console.log(ind, this.tableFields)
            this.tableFields[ind].sort_order =
                field.sort_order == 0 ? 2 : field.sort_order == 1 ? 2 : 1;
            console.log("Sort Order", this.tableFields[ind].sort_order);
            if (this.tableFields[ind].sort_order === 2) {
                // console.log("Sort 1");
                if (field.isNumeric) {
                    this.rawData = this.rawData.sort((a, b) => {
                        console.log(field.title, (field.title).search("rank"))
                        if ((typeof a[field.title] !== "string" && typeof b[field.title] !== "string") || (field.title).search("rank") !== -1) {
                            return a[field.title] < b[field.title] ?
                                1 :
                                b[field.title] < a[field.title] ?
                                    -1 :
                                    0;
                        } else if (typeof a[field.title] === "string") {
                            return 1;
                        } else if (typeof b[field.title] === "string") {
                            return -1
                        }
                    });
                } else {
                    this.rawData = this.rawData.sort((a, b) => {
                        return a[field.title].toLowerCase() < b[field.title].toLowerCase() ?
                            1 :
                            b[field.title].toLowerCase() < a[field.title].toLowerCase() ?
                                -1 :
                                0;
                    });
                }
            } else if (this.tableFields[ind].sort_order === 1) {
                console.log(field.title, (field.title).search("rank"))
                if (field.isNumeric) {
                    console.log(field.title, (field.title).search("rank"))
                    this.rawData = this.rawData.sort((a, b) => {
                        console.log(field.title, (field.title).search("rank"))
                        if ((typeof a[field.title] !== "string" && typeof b[field.title] !== "string") || (field.title).search("rank") !== -1) {
                            return a[field.title] > b[field.title] ?
                                1 :
                                b[field.title] > a[field.title] ?
                                    -1 :
                                    0;
                        } else if (typeof a[field.title] === "string" && typeof b[field.title] === "string") {
                            return 0;
                        } else if (typeof a[field.title] === "string") {
                            return -1;
                        } else if (typeof b[field.title] === "string") {
                            return -1;
                        }
                    });
                } else {
                    this.rawData = this.rawData.sort((a, b) => {
                        // console.log(a[field.title], b[field.title], field.isNumeric);
                        return a[field.title].toLowerCase() > b[field.title].toLowerCase() ?
                            1 :
                            b[field.title].toLowerCase() > a[field.title].toLowerCase() ?
                                -1 :
                                0;
                    });
                }
            }
        },
        sortPColumn(field, ind) {
            console.log(ind, this.tablefields)
            this.tablefields[ind].sort_order =
                field.sort_order == 0 ? 2 : field.sort_order == 1 ? 2 : 1;
            console.log("Sort Order", this.tablefields[ind].sort_order);
            if (this.tablefields[ind].sort_order === 2) {
                // console.log("Sort 1");
                if (field.isNumeric) {
                    this.rawdata = this.rawdata.sort((a, b) => {
                        console.log(field.title, (field.title).search("rank"))
                        if ((typeof a[field.title] !== "string" && typeof b[field.title] !== "string") || (field.title).search("rank") !== -1) {
                            return a[field.title] < b[field.title] ?
                                1 :
                                b[field.title] < a[field.title] ?
                                    -1 :
                                    0;
                        } else if (typeof a[field.title] === "string") {
                            return 1;
                        } else if (typeof b[field.title] === "string") {
                            return -1
                        }
                    });
                } else {
                    this.rawdata = this.rawdata.sort((a, b) => {
                        return a[field.title].toLowerCase() < b[field.title].toLowerCase() ?
                            1 :
                            b[field.title].toLowerCase() < a[field.title].toLowerCase() ?
                                -1 :
                                0;
                    });
                }
            } else if (this.tablefields[ind].sort_order === 1) {
                console.log(field.title, (field.title).search("rank"))
                if (field.isNumeric) {
                    console.log(field.title, (field.title).search("rank"))
                    this.rawdata = this.rawdata.sort((a, b) => {
                        console.log(field.title, (field.title).search("rank"))
                        if ((typeof a[field.title] !== "string" && typeof b[field.title] !== "string") || (field.title).search("rank") !== -1) {
                            return a[field.title] > b[field.title] ?
                                1 :
                                b[field.title] > a[field.title] ?
                                    -1 :
                                    0;
                        } else if (typeof a[field.title] === "string" && typeof b[field.title] === "string") {
                            return 0;
                        } else if (typeof a[field.title] === "string") {
                            return -1;
                        } else if (typeof b[field.title] === "string") {
                            return -1;
                        }
                    });
                } else {
                    this.rawdata = this.rawdata.sort((a, b) => {
                        // console.log(a[field.title], b[field.title], field.isNumeric);
                        return a[field.title].toLowerCase() > b[field.title].toLowerCase() ?
                            1 :
                            b[field.title].toLowerCase() > a[field.title].toLowerCase() ?
                                -1 :
                                0;
                    });
                }
            }
        },
        sortPDataColumn(field, ind, col = null) {
            if (field.title === 'market_capitalization') {
                this.sortColumn(field, ind);
            } else {
                console.log(ind, this.tablefields, col, field)
                this.tablefields[ind].sort_order =
                    field.sort_order == 0 ? 2 : field.sort_order == 1 ? 2 : 1;
                console.log("Sort Order", this.tablefields[ind].sort_order);
                if (this.tablefields[ind].sort_order === 2) {
                    // console.log("Sort 1");
                    if (field.isNumeric) {
                        this.rawdata = this.rawdata.sort((a, b) => {
                            console.log(field.title, (field.title).search("rank"))
                            if ((typeof a[col][field.title] !== "string" && typeof b[col][field.title] !== "string") || (field.title).search("rank") !== -1) {
                            // if ((field.title).search("rank") !== -1) {
                                return parseFloat(a[col][field.title]) < parseFloat(b[field.title]) ?
                                    1 :
                                    parseFloat(b[col][field.title]) < parseFloat(a[col][field.title]) ?
                                        -1 :
                                        0;
                            } else if ((typeof a[col][field.title] === "string" && typeof b[col][field.title] === "string")) {
                                return 0;
                            } else if (typeof a[col][field.title] === "string") {
                                return 0;
                            } else if (typeof b[col][field.title] === "string") {
                                return 0
                            }
                        });
                    } else {
                        this.rawdata = this.rawdata.sort((a, b) => {
                            return a[col][field.title].toLowerCase() < b[col][field.title].toLowerCase() ?
                                1 :
                                b[col][field.title].toLowerCase() < a[col][field.title].toLowerCase() ?
                                    -1 :
                                    0;
                        });
                    }
                } else if (this.tablefields[ind].sort_order === 1) {
                    console.log(field.title, (field.title).search("rank"))
                    if (field.isNumeric) {
                        console.log(field.title, (field.title).search("rank"))
                        this.rawdata = this.rawdata.sort((a, b) => {
                            console.log(field.title, (field.title).search("rank"))
                            if ((typeof a[col][field.title] !== "string" && typeof b[col][field.title] !== "string") || (field.title).search("rank") !== -1) {
                                return a[col][field.title] > b[col][field.title] ?
                                    1 :
                                    b[col][field.title] > a[col][field.title] ?
                                        -1 :
                                        0;
                            } 
                            // else if (typeof a[col][field.title] === "string" && typeof b[col][field.title] === "string") {
                            //     return -1;
                            // // } 
                            else if (typeof a[col][field.title] === "string") {
                                return -1;
                            } else if (typeof b[col][field.title] === "string") {
                                return -1;
                            }
                        });
                    } else {
                        this.rawdata = this.rawdata.sort((a, b) => {
                            // console.log(a[field.title], b[field.title], field.isNumeric);
                            return a[col][field.title].toLowerCase() > b[col][field.title].toLowerCase() ?
                                1 :
                                b[col][field.title].toLowerCase() > a[col][field.title].toLowerCase() ?
                                    -1 :
                                    0;
                        });
                    }
                }
            }
        },
        checkNotInArray(data, element) {
            // console.log(data, element);
            return data.indexOf(element) === -1 ? true : false;
        },
        checkInArray(data, element) {
            return data.includes(element);
        },
        filterData() {
            if (this.selFilter !== "") {
                if (this.minRange == "" && this.maxRange == "") {
                    this.rawData = this.searchData;
                    return this.rawData;
                } else {
                    this.rawData = this.searchData.filter(rd => {
                        // console.log(rd, this.selFilter);
                        if (this.minRange != "" && this.maxRange != "") {
                            return (
                                parseInt(rd[this.selFilter]) >= parseInt(this.minRange) &&
                                parseInt(rd[this.selFilter]) <= parseInt(this.maxRange)
                            );
                        } else {
                            if (this.minRange != "") {
                                return parseInt(rd[this.selFilter]) >= parseInt(this.minRange);
                            }
                            if (this.maxRange != "") {
                                return parseInt(rd[this.selFilter]) <= parseInt(this.maxRange);
                            }
                        }
                    });
                }
            }
        },
        getDataInRatio(orgData) {
            // var  orgData = [10275.6, 10335.93, 9586.88, 9406.47, 9110.05, 9071.36, 9370.49, 9046.74, 9323.59, 9329.57, 9100.55, 8779.17, 8813.84, 8674.35, 9004.08, 9257.47, 9236.28, 9424.24, 9066.7, 9149.3, 9201.85, 9090.88, 9300.86, 9583.89, 9647.47, 9618.54, 9465.83, 9634.74, 9305.45, 9035, 9015.18, 9042.63, 8843.21, 8822.06, 8902.56, 8954.86, 8891.61, 8607.08, 8427.29, 8446.49, 8197.92, 8325.82, 8160.4, 8343.75, 8756.61, 8943.54, 8863.82, 8976.68, 9001.75, 8966.68, 9424.02, 9471.04, 9667.9, 10003.1, 10048.49, 9568.14, 9708.5, 9901.99, 10348.83, 10534.87, 10742.34, 10803.86, 10967.22, 11284.73, 10947.4, 11023.09, 10979.5, 10898.11, 10817.54, 11134.99, 11329.05, 11371.85, 11001.75, 11403.25, 12134.75, 12131.08, 11952.75, 12116.94, 11876.43, 11682.99, 12158.03, 12019.65, 11872.91, 12173.42, 14284.21, 14302.03, 14060.66, 13736.54, 13887.15, 13913.22, 13589.23, 14109.64, 14296.01, 14625.25, 14840.63, 14874.91, 14870.9, 15008.68, 15103.55, 14665.92];
            console.log("data length", orgData.length);
            var newData = [];
            orgData.forEach((val, key) => {
                // console.log(val);
                if (key === 0) {
                    newData.push((100).toFixed(2));
                } else {
                    var dd = parseFloat((100 * parseFloat(val)) / parseFloat(orgData[0]));
                    // console.log("getDataInRatio", val, orgData[0], dd);
                    newData.push(dd.toFixed(2));
                }
            });
            return newData;

        },
        getDataInRatioWithFields(orgData, field) {
            // var  orgData = [10275.6, 10335.93, 9586.88, 9406.47, 9110.05, 9071.36, 9370.49, 9046.74, 9323.59, 9329.57, 9100.55, 8779.17, 8813.84, 8674.35, 9004.08, 9257.47, 9236.28, 9424.24, 9066.7, 9149.3, 9201.85, 9090.88, 9300.86, 9583.89, 9647.47, 9618.54, 9465.83, 9634.74, 9305.45, 9035, 9015.18, 9042.63, 8843.21, 8822.06, 8902.56, 8954.86, 8891.61, 8607.08, 8427.29, 8446.49, 8197.92, 8325.82, 8160.4, 8343.75, 8756.61, 8943.54, 8863.82, 8976.68, 9001.75, 8966.68, 9424.02, 9471.04, 9667.9, 10003.1, 10048.49, 9568.14, 9708.5, 9901.99, 10348.83, 10534.87, 10742.34, 10803.86, 10967.22, 11284.73, 10947.4, 11023.09, 10979.5, 10898.11, 10817.54, 11134.99, 11329.05, 11371.85, 11001.75, 11403.25, 12134.75, 12131.08, 11952.75, 12116.94, 11876.43, 11682.99, 12158.03, 12019.65, 11872.91, 12173.42, 14284.21, 14302.03, 14060.66, 13736.54, 13887.15, 13913.22, 13589.23, 14109.64, 14296.01, 14625.25, 14840.63, 14874.91, 14870.9, 15008.68, 15103.55, 14665.92];
            console.log("data length", orgData.length);
            var newData = [];
            orgData.forEach((val, key) => {
                // console.log(val);
                if (key === 0) {
                    newData.push((100).toFixed(2));
                } else {
                    var dd = parseFloat((100 * parseFloat(val)) / parseFloat(orgData[0]));
                    // console.log("getDataInRatio", val, orgData[0], dd);
                    newData.push(dd.toFixed(2));
                }
            });
            return newData;

        },
        minusMonths(dt, n) {
            console.log("Date passes", dt);
            return new Date(dt.setMonth(dt.getMonth() - n));
        },
        //Company Data
        showDetailView(row) {
            console.log("view clicked", row);
            localStorage.setItem("selcomp", JSON.stringify({ companyname: (row.companyname) ? row.companyname : row.name, co_code: row.co_code }));
            // http.post("final_data", { co_code: row.co_code }, (error, response) => {
            //   // console.log("RawData", response);
            //   localStorage.setItem("selcomp", JSON.stringify({companyname: row.companyname, co_code: row.co_code}));
            //   let company = response.data.length > 0 ? response.data[0] : [];
            this.$router.push({
                name: "viewcompany",
                params: { company: {} }
                // });
                //TODO:: add company updates into our array in future
            });
        },
        editCompany(row) {
            console.log("editing row", row);
            http.post("final_data", {
                co_code: row.co_code
            }, (error, response) => {
                localStorage.setItem("selcomp", JSON.stringify({
                    companyname: row.companyname,
                    co_code: row.co_code
                }));
                // console.log("RawData", response);
                setTimeout(() => {
                    this.$router.push({
                        name: "editcompany",
                        params: {
                            company: response.data[0]
                        },
                        // query: Object.assign({}, this.$route.query, {
                        //     id: row.co_code
                        // })
                    });
                }, 200);
                //TODO:: add company updates into our array in future
            });
            // this.$router.push({ name: "editcompany", params: { company: row } });
        },
        viewCalculatedData(row) {
            localStorage.setItem("selcomp", JSON.stringify({ companyname: row.companyname, co_code: row.co_code }));
            this.$router.push({ name: "calculateddata", params: { company: row } });
            //`rawdata/${row}`
        },
        //Pdata
        getPData() {
            this.rawData = {};
            let myself = this;
            http.post(
                myself.rawDataApi, {
                    my_date: myself.getDate(myself.ddate),
                    m_filter: myself.selFilter,
                    min_range: myself.minRange,
                    max_range: myself.maxRange,
                    sector: myself.sectorname
                },
                (error, response) => {
                    console.log('response >>>', response);
                    if (response.length > 0) {
                        myself.rawData = response;
                        myself.searchData = response;
                        console.log(new Date(myself.rawData[0].date));
                        myself.ddate = new Date(myself.rawData[0].date);
                        console.log(myself.searchData);
                    }
                }
            );
        },
        filtData(obj) {
            console.log("Filter", obj, JSON.stringify(obj));
            this.ddate = new Date(obj.durDate);
            this.minRange = obj.min;
            this.maxRange = obj.max;
            this.selFilter = obj.selField;
            this.sectorname = obj.sector;
            this.getPData();
        },
        filterRangeData(event) {
            this.clearData();
            var ind = event.target.value;
            this.selRangeFilter = this.mcOptions[ind].id;
            if (this.selRangeFilter === 0) {
                this.rawData = this.searchData;
                return this.rawData;
            } else {
                var minRange = this.mcOptions[ind].min;
                var maxRange = this.mcOptions[ind].max;
                this.rawData = this.searchData.filter(rd => {
                    console.log(
                        rd.market_capitalization,
                        this.selRangeFilter,
                        minRange,
                        maxRange
                    );
                    if (minRange != "" && maxRange != "") {
                        return (
                            parseInt(rd["market_capitalization"]) >= parseInt(minRange) &&
                            parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
                        );
                    } else {
                        if (minRange != "") {
                            return (
                                parseInt(rd["market_capitalization"]) >= parseInt(minRange)
                            );
                        }
                        if (maxRange != "") {
                            return (
                                parseInt(rd["market_capitalization"]) <= parseInt(maxRange)
                            );
                        }
                    }
                });
            }
            setTimeout(() => {
                this.sortColumn(this.tableFields[2], 2);
            });
        },
        filteredList(e) {
            this.selRangeFilter = 0;
            this.selFilter = "";
            if (this.searchText === null || this.searchText === "") {
                this.rawData = this.searchData;
                return this.rawData;
            } else if (this.searchText.length <= 2) {
                this.rawData = this.searchData;
                return this.rawData;
            }
            if (this.searchText.length > 2 || e.keyCode === 13) {
                this.rawData = this.searchData.filter(rd => {
                    console.log(rd.company_name, rd);
                    return (
                        rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
                            (rd.name) ?
                            rd.name.toLowerCase().includes(this.searchText.toLowerCase()) : false ||
                                (rd.company_name) ? rd.company_name.toLowerCase().includes(this.searchText.toLowerCase()) : false
                    );
                });
            }
        },
        clearData() {
            this.selRangeFilter = 0;
            this.selFilter = "";
            this.sectorname = "";
            this.searchText = "";
            this.rawData = this.searchData;
        },
        getIndexOfObject(data, field, value) {
            data.forEach(function (row, index) {
                if (row[field] == value) return index;
            });
        },
        tableToExcel: (function () {
            {
                console.log("Function call");
                var uri = "data:application/vnd.ms-excel;base64,",
                    template =
                        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head filename:><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
                        name +
                        '</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
                    base64 = function (s) {
                        return window.btoa(unescape(encodeURIComponent(s)));
                    },
                    format = function (s, c) {
                        return s.replace(/{(\w+)}/g, function (m, p) {
                            return c[p];
                        });
                    };
                return function (table, name) {
                    if (!table.nodeType) table = document.getElementById(table);
                    var ctx = {
                        worksheet: name || "Worksheet",
                        table: table.innerHTML
                    };
                    var link = document.createElement("a");
                    link.download = name + ".xls";
                    // window.location.href = uri + base64(format(template, ctx))
                    link.href = uri + base64(format(template, ctx));
                    link.click();
                };
            }
        })(),
    },
    mounted() {
    }
}


// WEBPACK FOOTER //
// ./src/assets/mixins/common.js